/* unplugin-vue-components disabled */import { render } from "./Spinner.vue?vue&type=template&id=7a6ac628"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=7a6ac628&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__